<div class="cabecera-govco">
  <!-- Barra Superior -->
  <div class="barra-superior-govco">
    <a
      href="https://www.gov.co/"
      target="_blank"
      rel="noopener"
      aria-label="Portal del Estado Colombiano - GOV.CO"></a>
    <button
      class="idioma-btn-barra-superior-govco"
      aria-label="Button to change the language of the page to English"
      (click)="changeLanguage()"
      [ngClass]="{
        es: translateService.currentLang === 'en',
        en: translateService.currentLang === 'es',
      }"></button>
  </div>

  <div class="d-none d-md-block">
    <div class="barra-inferior-govco">
      <div class="barra-logos-govco">
        <img [src]="entidadJustifacil.logoMiniUrl"
             style="width: 8%; height: auto;"
             alt="Logo Justicia">
      </div>
    </div>
  </div>
</div>
